import { UpDownBarType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/stock-chart.interface';
import { ShapeProps } from '../../../../../Interface/chart-v3/chart-properties.interface';
import ChartShapeProperty from '../../../chart-shape-property';
import { IChartShapeProperty, NullableDeep } from '../../../chart-shape-property.interface';

export class UpDownBarProperty extends ChartShapeProperty implements IChartShapeProperty {
    private barType: UpDownBarType;

    public init(barType: UpDownBarType) {
        this.barType = barType;
        return this;
    }

    public updateProps(updateProps: Partial<ShapeProps>, removeProps?: Partial<NullableDeep<ShapeProps>>): void {
        const subChartModel = this.context.getSubChartModel();
        const update = {
            upDownBars: {
                [this.barType]: updateProps,
            },
        };
        const remove = {
            upDownBars: {
                [this.barType]: removeProps,
            },
        };
        subChartModel.updateAndRemoveProps(update, remove);
    }
}
